export default __webpack_public_path__ + "static/media/ic_map_latin_america_hub.3594d87d.svg";